import { type FC } from "react";

import { useTrackPageView } from "@application/hooks/use_track_page_view";

import { Title } from "@styled/title";

import { Closing } from "./home/closing";
import { Expertise } from "./home/expertise";
import { Hero } from "./home/hero";
import { Intelligence } from "./home/intelligence";
import { Nav } from "./home/nav";
import { ReviewLoop } from "./home/review_loop";
import { Scale } from "./home/scale";
import { Segments } from "./home/segments";
import { SiteFooter } from "./home/site_footer";
import { useHomeSegments } from "./home/use_home_segments";

// The head for `/` is emitted server-side by SocialComponent (see
// app/views/main/index.html.erb): scrapers do not run JS, and rendering <Social/>
// here too would duplicate every tag once React hoists it. <Title/> renders no
// markup — it only keeps document.title right on client-side navigation back to `/`.
const HOME_TITLE = "Workflow Labs · Case Intelligence Workbench";

// Not PageLayout: this page carries the kit's own nav, footer and 1120px wrap.
// `home-page` is load-bearing — styles/home.css is scoped entirely under it, so
// its bare `nav`/`h1`/`.card`/`.link` rules cannot reach the rest of the app.
export const Home: FC = () => {
  useTrackPageView({ page: "home" });

  const { segment, copySegment, fading, washing, select, endWash } =
    useHomeSegments();

  return (
    <>
      <Title>{HOME_TITLE}</Title>

      <div className="home-page">
        <Nav onSelect={select} />

        <Hero />

        <Segments segment={segment} onSelect={select} />

        <Intelligence
          copySegment={copySegment}
          fading={fading}
          washing={washing}
          onWashEnd={endWash}
        />

        <Expertise />

        <Scale />

        <ReviewLoop />

        <Closing />

        <SiteFooter />
      </div>
    </>
  );
};
